/* tslint:disable */
/* eslint-disable */
/**
 * Selling Partner API for Fulfillment Inbound
 * The Selling Partner API for Fulfillment Inbound lets you create applications that create and update inbound shipments of inventory to Amazon\'s fulfillment network.
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Indicates the status of the inbound shipment. When used with the createInboundShipment operation, WORKING is the only valid value. When used with the updateInboundShipment operation, possible values are WORKING, SHIPPED or CANCELLED.
 */

export const ShipmentStatus = {
    Working: 'WORKING',
    Shipped: 'SHIPPED',
    Receiving: 'RECEIVING',
    Cancelled: 'CANCELLED',
    Deleted: 'DELETED',
    Closed: 'CLOSED',
    Error: 'ERROR',
    InTransit: 'IN_TRANSIT',
    Delivered: 'DELIVERED',
    CheckedIn: 'CHECKED_IN',
} as const;

export type ShipmentStatus = typeof ShipmentStatus[keyof typeof ShipmentStatus];



